import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import NextImage from 'next/legacy/image';
import stackIcon from './stack-icon.svg';

export interface AlsoAvailableOnModalButtonProps {
  children: React.ReactNode;
  handleClick: () => void;
}

export const AlsoAvailableOnModalButton = ({
  children,
  handleClick,
}: AlsoAvailableOnModalButtonProps) => {
  return (
    <Button
      intent={constants.PRIMARY}
      size={constants.SMALL}
      onClick={handleClick}
      iconBefore={
        // {/* The stackIcon serves as a decoration rather than giving any useful info to the users,
        //     therefore it doesn't need an alt text
        // */}
        <NextImage
          alt=""
          layout="fixed"
          src={stackIcon}
          width={16}
          height={16}
        />
      }
    >
      {children}
    </Button>
  );
};
